import React, { useEffect, useState } from "react";
import "./write.css";

function encode(data) {
  return Object.keys(data)
    .map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&");
}

function Write() {
  const [open, setOpen] = useState(false);
  const [state, setState] = useState({});
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => (document.body.style.overflow = "");
  }, [open]);

  const handleChange = (e) => {
    setState((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({ "form-name": "review", ...state }),
    })
      .then(() => {
        setSuccess(true);
      })
      .catch(alert);
  };

  const closeModal = () => {
    setOpen(false);
    setSuccess(false);
    setState({});
  };

  return (
    <>
      <form
        name="review"
        method="POST"
        data-netlify="true"
        netlify-honeypot="bot-field"
        hidden
      >
        <input type="hidden" name="form-name" value="review" />
        <input type="hidden" name="bot-field" />

        <input type="text" name="name" />
        <input type="email" name="email" />
        <select name="stars"></select>
        <textarea name="message"></textarea>
      </form>

      <button className="write-review-btn" onClick={() => setOpen(true)}>
        Add Review
      </button>

      {open && (
        <div className="modal-overlay" onClick={closeModal}>
          <div
            className="modal-content fade-in-5"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="modal-close" onClick={closeModal}>
              ×
            </button>

            <h2 className="write-review-header">Write a Review</h2>

            {success ? (
              <p className="message-sent-2">Thanks! Your review was sent.</p>
            ) : (
              <form
                name="review"
                method="POST"
                onSubmit={handleSubmit}
                className="contact-form"
                data-netlify="true"
                netlify-honeypot="bot-field"
              >
                <input type="hidden" name="form-name" value="review" />
                <input type="hidden" name="bot-field" onChange={handleChange} />

                <input
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  onChange={handleChange}
                  required
                />

                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  onChange={handleChange}
                  required
                />

                <select
                  name="stars"
                  onChange={handleChange}
                  required
                  defaultValue=""
                  className="select"
                >
                  <option value="" disabled>
                    Rating
                  </option>
                  <option value="5">★★★★★ (5)</option>
                  <option value="4">★★★★ (4)</option>
                  <option value="3">★★★ (3)</option>
                  <option value="2">★★ (2)</option>
                  <option value="1">★ (1)</option>
                </select>

                <textarea
                  name="message"
                  placeholder="Write your review"
                  onChange={handleChange}
                  required
                />

                <button type="submit" className="submit-2">
                  Send Review
                </button>
              </form>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default Write;
